import {
    PD_CATEGORY_ROW_TALL,
    PD_FULL_IMAGE_X4,
    PD_FULL_WIDTH_IMAGE_HEADLINE_LINK,
    PD_HERO,
    PD_HERO_SLIDER,
    PD_IMAGE_ROW_OF_TWO,
    PD_PROMO_PAIRABLE_STYLES,
    PD_RECOMMENDATIONS,
    PD_RECOMMENDATIONS_EINSTEIN,
    PD_SHOP_THE_LOOK,
    PD_SHOP_THE_LOOK_GALLERY,
    PD_SHOP_THE_LOOK_GALLERY_ITEM,
    PD_SHOP_THE_LOOK_SLIDER,
    PD_STORY_TELLING,
    PD_TEXT_ONLY
} from '../constants'

export const getPlpPdComponents = () => {
    return [
        PD_IMAGE_ROW_OF_TWO,
        PD_SHOP_THE_LOOK,
        PD_SHOP_THE_LOOK_GALLERY,
        PD_SHOP_THE_LOOK_GALLERY_ITEM,
        PD_SHOP_THE_LOOK_SLIDER,
        PD_CATEGORY_ROW_TALL,
        PD_FULL_IMAGE_X4,
        PD_RECOMMENDATIONS_EINSTEIN,
        PD_RECOMMENDATIONS,
        PD_FULL_WIDTH_IMAGE_HEADLINE_LINK,
        PD_PROMO_PAIRABLE_STYLES,
        PD_STORY_TELLING,
        PD_HERO,
        PD_HERO_SLIDER,
        PD_TEXT_ONLY
    ]
}
